// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1MHcK","dragIcon":"Choice_dragIcon__149zJ","left":"Choice_left__3b1HU","input":"Choice_input__35mdy"};